import { render } from "./OrderTimer.vue?vue&type=template&id=5ca660f8&scoped=true&ts=true&lang=pug"
import script from "./OrderTimer.vue?vue&type=script&lang=ts"
export * from "./OrderTimer.vue?vue&type=script&lang=ts"

import "./OrderTimer.vue?vue&type=style&index=0&id=5ca660f8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca660f8"]])

export default __exports__